import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Icon from './Icon';

/**
 * Компонент CategoryFilters - фильтры категорий с современным дизайном
 * 
 * @param {array} categories - Массив категорий
 * @param {string} activeCategory - ID активной категории
 * @param {function} setActiveCategory - Функция изменения активной категории
 * @param {boolean} useLinks - Использовать ли ссылки для навигации (true) или только обработчики (false)
 */
const CategoryFilters = ({ categories, activeCategory, setActiveCategory, useLinks = true }) => {
  const navigate = useNavigate();
  
  const handleCategoryClick = (categoryId) => {
    setActiveCategory(categoryId);
    
    if (useLinks) {
      navigate(`/category/${categoryId}`);
    }
  };
  
  return (
    <div className="flex overflow-x-auto hide-scrollbar py-2 space-x-2 mb-8">
      {categories.map((category) => {
        // Если используем ссылки, создаем Link, иначе обычную кнопку
        const ButtonOrLink = useLinks ? Link : 'button';
        const linkProps = useLinks ? { to: `/category/${category.slug}` } : {};
        
        return (
          <ButtonOrLink
            key={category.id}
            {...linkProps}
            onClick={() => handleCategoryClick(category.id)}
            className={`
              whitespace-nowrap px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200
              ${activeCategory === category.id 
                ? 'bg-indigo-600 text-white shadow-sm' 
                : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 border border-gray-200 dark:border-gray-700'}
            `}
          >
            <div className="flex items-center space-x-2">
              <Icon 
                name={category.iconName}
                color={activeCategory === category.id ? "gray" : category.color || "indigo"}
                className={activeCategory === category.id ? "text-white" : ""}
              />
              <span>{category.name}</span>
            </div>
          </ButtonOrLink>
        );
      })}
      
      <style jsx global>{`
        .hide-scrollbar {
          scrollbar-width: none;
          -ms-overflow-style: none;
        }
        
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
};

export default CategoryFilters;